/* eslint-disable no-unused-vars */
import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from './variants/input/Input';
import { logout, authActions } from 'store/auth/auth';
import RoundBTN from './variants/roundBtn/RoundBtn';
import * as S from './DropDownMenu.styled';
import { saveLocalStorageItem } from 'utils';
import {
  redirectToOldPlatformUrl,
  redirectToOldPlatformLoginUrl,
  getIsLocalHost,
  isPrefixInUrl,
} from 'utils';

export const Variants = {
  Input: 'INPUT',
  RoundBTN: 'ROUND_BTN',
  RoundBTNDefault: 'ROUND_BTN_DEFAULT',
};

const DropDownMenu = ({ values, defaultValue, variant, isLoading }) => {
  const dispatch = useDispatch();
  const pb_number = useSelector((state) => state.auth.pb_number);
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);

  const itemClicked = useCallback((action) => {
    let newUrl = '';
    switch (action.key) {
      case 'logout':
        //dispatch(logout());
        //if (getIsLocalHost()) {
        saveLocalStorageItem({
          key: 'tableState',
          field: 'filteredCampaigns',
          value: [],
        });
        if (window.REACT_APP_ENV === 'qa') {
          dispatch(authActions.clearAuthState());
          if (isPrefixInUrl()) {
            const { origin } = window.location;
            const newUrl = origin.replace(`${pb_number}.`, '');
            console.log(`${newUrl}${window.SUB_DOMAIN}/adminLogin`);
            window.location.href = `${newUrl}${window.SUB_DOMAIN}/adminLogin`;
          } else {
            navigate('/userLogin');
          }
        } else {
          const newUrl = redirectToOldPlatformLoginUrl(`/login2.aspx`);
          console.log(newUrl);
          window.location.href = newUrl;
        }
        break;
      case 'payments':
        if (window.REACT_APP_ENV === 'production') {
          newUrl = redirectToOldPlatformUrl(`/Publisher/Payments.aspx`);
          window.location.href = newUrl;
        } else if (window.REACT_APP_ENV === 'development') {
          navigate('/payments');
        } else if (window.REACT_APP_ENV === 'qa') {
          navigate('/payments');
        }
        break;
      case 'settings':
        if (window.REACT_APP_ENV === 'production') {
          newUrl = redirectToOldPlatformUrl(`/Publisher/Settings.aspx`);
          window.location.href = newUrl;
        } else if (window.REACT_APP_ENV === 'development') {
          navigate('/account-settings');
        } else if (window.REACT_APP_ENV === 'qa') {
          navigate('/account-settings');
        }
        break;
      default:
        break;
    }
  }, []);

  const onOptionClicked = useCallback((value) => {
    setSelectedOption(value);
    setIsOpen(false);
    itemClicked(value);
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const ComponentToShow = () => {
    switch (variant) {
      case Variants.Input:
        return (
          <Input
            toggling={() => setIsOpen(!isOpen)}
            // toggling={() => {
            //   const newUrl = redirectToOldPlatformLoginUrl(`/login2.aspx`);
            //   window.location.href = newUrl;
            // }}
            isOpen={isOpen}
            selectedOption={selectedOption}
            values={values}
            isLoading={isLoading}
          />
        );
      case Variants.RoundBTNDefault:
        return (
          <RoundBTN
            toggling={() => setIsOpen(!isOpen)}
            isOpen={isOpen}
            dropdownHeader={defaultValue}
            values={values}
            onOptionClicked={onOptionClicked}
          />
        );
      default:
        return;
    }
  };

  return (
    <>
      {isOpen && <S.Slice onClick={() => setIsOpen(false)} />}
      {ComponentToShow()}
    </>
  );
};

DropDownMenu.Variants = {
  ...Variants,
};

export default DropDownMenu;
